<template>
  <a-spin :spinning="loading">
    <a-empty v-if="sysAgentId == ''" :description="$t('msg.I_K0011008_01')" style="margin: 10% 0px" />
    <div v-else>
      <div style="padding-top: 10px">
        <a-form :form="form" @keyup.enter.native="handleOk" :label-col="labelCol" :wrapper-col="wrapperCol">
          <!-- 代理先 -->
          <a-form-item :label="$t('disp.agent')">
            <j-input-popup
              v-decorator="['agentId', validatorRules.agentId]"
              component="SelectUserTreeModal"
              :params="{
                multiFlg: '0',
                departFlg: '1',
              }"
              @change="setAgentInfo"
              :placeholder="$t('disp.ph.select', [$t('disp.agent')])"
            ></j-input-popup>
          </a-form-item>
          <!-- 代理期間 -->
          <a-form-item :label="$t('disp.agent.applyDateRange')">
            <a-range-picker
              style="width: 100%"
              :placeholder="[$t('disp.ph.ymdStart'), $t('disp.ph.ymdEnd')]"
              format="YYYY-MM-DD"
              @change="onApplyDateChange"
              v-decorator="[
                'applyDateRange',
                {
                  initialValue: applyDateRangeInit,
                  rules: [{ required: true, message: this.$t('disp.rules.require') }],
                },
              ]"
            />
          </a-form-item>
          <!-- 委譲権限 -->
          <a-form-item :label="$t('disp.agent.delegationPerms')">
            <j-dict-select-tag
              v-decorator="['delegationPerms', validatorRules.delegationPerms]"
              :type="'radio'"
              :triggerChange="true"
              dictCode="delegation_perms"
            />
          </a-form-item>
          <!-- 権限対象設定 -->
          <a-form-item :label="$t('disp.agent.permissionSet')">
            <div>
              <a-transfer
                :data-source="permissionList"
                :titles="['', '']"
                :list-style="{
                  width: 'calc(50% - 24px)',
                  height: '298px',
                }"
                :target-keys="targetKeys"
                :selected-keys="selectedKeys"
                :render="(item) => item.title"
                :disabled="disabled"
                @change="handleChange"
                @selectChange="handleSelectChange"
                @scroll="handleScroll"
              />
            </div>
          </a-form-item>
          <!-- 备注 -->
          <a-form-item :label="$t('disp.note')">
            <a-textarea
              @keyup.enter.stop
              v-decorator="['memo', {}]"
              :maxLength="255"
              :placeholder="$t('disp.ph.input', [$t('disp.note')])"
            />
          </a-form-item>

          <a-divider></a-divider>
          <a-form-item
            style="margin-bottom: 0px; margin-top: -16px"
            :wrapperCol="{
              xs: { span: 24 },
              sm: { span: 24 },
              md: { span: 23 },
              lg: { span: 22 },
              xl: { span: 21 },
              xxl: { span: 20 },
            }"
            label
          >
            <a-button
              @click="handleSubmit(true)"
              type="primary"
              htmlType="button"
              icon="check"
              style="float: right; margin-right: 0px; margin-bottom: 10px"
              >{{ $t('disp.btn.confirm') }}</a-button
            >
          </a-form-item>
        </a-form>
      </div>
    </div>
  </a-spin>
</template>
<script>
import pick from 'lodash/pick'
import { deleteAction, postAction, getAction } from '@/api/manage'
import { addRole, editRole, duplicateCheck } from '@/api/api'
import JInputPopup from '@/components/JInputPopup'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import moment from 'moment'

export default {
  name: 'AgentInfoModal',
  components: {
    JInputPopup,
    JDictSelectTag,
  },
  data() {
    return {
      records: [],
      queryParam: {},
      sysAgentId: '',
      autoExpandParent: true,
      checkStrictly: true,
      loading: false,
      model: {},
      // 権限対象設定
      permissionList: [],
      // 権限対象設定
      targetKeys: [],
      // 権限対象設定selectedKeys
      selectedKeys: [],
      // 権限対象設定disabled
      disabled: false,
      // 期间（编辑用）
      applyDateRangeInit: [],
      // 代理先param
      parentParams: { status: '1', multiFlg: '0' },
      labelCol: {
        xs: { span: 5 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 15 },
        sm: { span: 15 },
      },
      form: this.$form.createForm(this),
      // 代理先
      agentId: '',
      validatorRules: {
        agentId: {
          rules: [{ required: true, message: this.$t('disp.rules.require') }],
        },
        delegationPerms: {
          rules: [{ required: true, message: this.$t('disp.rules.require') }],
        },
      },
      url: {
        add: '/blaze-sys/k00/k0011/AgentManage/add',
        edit: '/blaze-sys/k00/k0011/AgentManage/edit',
        check: '/blaze-sys/k00/k0011/AgentManage/check',
        permissionList: '/blaze-sys/k00/k0011/AgentManage/permissionList',
        agentInfo: '/blaze-sys/k00/k0011/AgentManage/agentInfo',
      },
    }
  },
  methods: {
    moment,
    /** edit */
    edit(record) {
      this.visible = true
      this.sysAgentId = record.id

      getAction(this.url.agentInfo, { id: this.sysAgentId }).then((res) => {
        if (res.success) {
          // 権限対象
          this.clearPermissionList()
          let permissionList = res.result.permissionList
          for (let i = 0; i < permissionList.length; i++) {
            this.permissionList.push({
              key: permissionList[i].id,
              title: permissionList[i].name,
            })
          }
          // 権限オブジェクト設定済
          this.targetKeys = res.result.agentDetailList
          // フォーム
          this.form.resetFields()
          this.model = Object.assign({}, res.result.agentInfo)
          this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.model, 'delegationPerms', 'memo'))

            // 代理先
            this.form.setFieldsValue({
              agentId: [{ value: this.model.agentId, text: this.model.agentName }],
            })
            this.agentId = this.model.agentId
            // 代理期間
            this.form.applyStartDate = this.model.applyStartDate
              ? moment(this.model.applyStartDate).format('YYYY-MM-DD')
              : null
            this.form.applyEndDate = this.model.applyEndDate
              ? moment(this.model.applyEndDate).format('YYYY-MM-DD')
              : null
            this.applyDateRangeInit = [
              this.model.applyStartDate ? moment(this.model.applyStartDate) : null,
              this.model.applyEndDate ? moment(this.model.applyEndDate) : null,
            ]
          })
        }
      })
    },
    /** clear */
    onClearSelected() {
      this.clearPermissionList()
    },
    onCheck(o) {},
    /** close */
    close() {
      this.reset()
      this.$emit('close')
      this.visible = false
    },
    onExpand(expandedKeys) {
      this.autoExpandParent = false
    },
    reset() {
      this.checkedKeys = []
      this.defaultCheckedKeys = []
      this.loading = false
    },
    expandAll() {},
    closeAll() {},
    checkALL() {
      this.checkedKeys = this.allTreeKeys
    },
    cancelCheckALL() {
      this.checkedKeys = []
    },
    switchCheckStrictly(v) {
      if (v == 1) {
        this.checkStrictly = false
      } else if (v == 2) {
        this.checkStrictly = true
      }
    },
    handleCancel() {
      this.close()
    },
    handleSubmit(exit) {
      this.handleOk()
    },
    open(record) {
      this.records = record
      this.agentId = record.agentId

      this.$refs.agentInfo.edit(record)
      this.$refs.agentInfo.title = this.$t('disp.btn.edit')
      this.$refs.agentInfo.disableSubmit = false
      this.visible = true
    },
    /** formDataとして整理 */
    classifyIntoFormData(formData) {
      return {
        agentInfo: formData,
        agentDetailList: this.targetKeys,
      }
    },
    /** 代理設定*/
    setAgentInfo(newName) {
      this.clearPermissionList()
      if (newName.length > 0) {
        let agentId = newName[0].value
        this.agentId = agentId
        getAction(this.url.permissionList, { id: agentId }).then((res) => {
          if (res.success) {
            let permissionList = res.result
            for (let i = 0; i < permissionList.length; i++) {
              this.permissionList.push({
                key: permissionList[i].id,
                title: permissionList[i].name,
              })
            }
          }
        })
      }
    },
    /** リストをクリア */
    clearPermissionList() {
      this.permissionList = []
      this.targetKeys = []
      this.selectedKeys = []
    },
    /** 代理期間change */
    onApplyDateChange: function (value, dateString) {
      this.form.applyStartDate = dateString[0]
      this.form.applyEndDate = dateString[1]
    },
    handleChange(nextTargetKeys, direction, moveKeys) {
      this.targetKeys = nextTargetKeys
    },
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys]
    },
    handleScroll(direction, e) {},
    handleDisable(disabled) {
      this.disabled = disabled
    },
    close() {},
    handleOk() {
      const that = this
      // フォーム検証をトリガー
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // 権限対象設定
          if (JSON.stringify(this.targetKeys) == '{}' || this.targetKeys.length == 0) {
            return this.$notification.error({
              message: this.$t('disp.error'),
              description: this.$t('msg.E_K0011008_02', [this.$t('disp.agent.permissionInfo')]),
            })
          }
          // 系统日付
          let nowDate = moment().utc().format('YYYY-MM-DD')
          let endDate = moment(that.form.applyEndDate)
          // システム日付は代理期間以外　且つ　代理期間が過去時間の場合
          if (endDate.isBefore(nowDate)) {
            this.$confirm({
              title: that.$t('msg.W_K0011008_04'),
              onOk() {
                that.doEdit(values)
              },
            })
          } else {
            that.doEdit(values)
          }
        }
      })
    },
    doEdit(values) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }
      const that = this
      // 編集
      let formData = this.classifyIntoFormData(values)
      formData.agentInfo.applyStartDate = that.form.applyStartDate
      formData.agentInfo.applyEndDate = that.form.applyEndDate
      formData.agentInfo.agentId = this.agentId
      formData.agentInfo.id = this.sysAgentId
      postAction(this.url.edit, formData)
        .then((res) => {
          if (res.success) {
            // 権限対象設定の右欄データが処理①で取得した権限情報に存在しないの場合
            if (res.message == 'msg.E_K0011008_03' || res.message == 'msg.E_K0011008_04') {
              let menuName = []
              for (let i = 0; i < that.permissionList.length; i++) {
                if (res.result.menuIdList.includes(that.permissionList[i].key)) {
                  menuName.push(that.permissionList[i].title)
                }
              }
              this.$notification.error({
                message: that.$t('disp.error'),
                description: that.$t(res.message, [that.$t(menuName.join(','))]),
              })
            } else {
              // 处理成功
              that.$message.success(that.$t(res.message))
              that.$emit('searchQuery')
            }
          }
        })
        .finally(() => {
          that.loading = false
        })
    },
  },
}
</script>
<style lang="less" scoped></style>
